<div class="modal-header">
  <h4 class="modal-title" style="width:300px" id="modal-basic-title">
    {{ 'bikeshop.modal.add_edit_user.add_user' | translate }}
  </h4>
  <div class="wizard">
    <ul>
      <li>
        <a class="first">
          <span class="wizard-step" [ngClass]="{ active: step === 1, complete: step > 1 }">
            <span [ngClass]="{'inner-circle':step === 1}"></span>
            <span [ngClass]="{ hide: step > 1 }"></span>
          </span>
          <span class="wizard-title" [ngClass]="{'active': step===1, 'complete' : step > 1}">
            {{'bikeshop.users.details' | translate}}
          </span>
        </a>
      </li>
      <li>
        <a>
          <span class="wizard-step" [ngClass]="{ active: step === 2, complete: step > 2 }">
            <span [ngClass]="{'inner-circle':step === 2}"></span>
            <span [ngClass]="{ hide: step > 2 }"></span>
          </span>
          <span class="wizard-title" [ngClass]="{'active': step===2, 'complete' : step > 2}">
            {{'bikeshop.users.roles' | translate}}
          </span>
        </a>
      </li>
    </ul>
  </div>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span class="hubtiger-close"></span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="step === 1">
    <form [formGroup]="UserForm" autocomplete="off">

      <div class="row margin-top-8">
        <div class="col-md-2 label">*{{ "general.email" | translate }}:</div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input type="text" pInputText autocomplete="off" formControlName="Email" (change)="searchUser($event)"
              placeholder="{{ 'general.email' | translate }}" />
          </div>
        </div>
        <div class="col-md-2 label">
          {{ "general.phone_number" | translate }}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input type="text" pInputText autocomplete="off" formControlName="PhoneNumber"
              placeholder="{{ 'general.phone_number' | translate }}" />
          </div>
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-2 label">
          *{{ "general.firstname" | translate }}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input type="text" autocomplete="off" pInputText placeholder="{{ 'general.firstname' | translate }}"
              formControlName="Name" />
          </div>
        </div>
        <div class="col-md-2 label">*{{ "general.surname" | translate }}:</div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input type="text" autocomplete="off" pInputText placeholder="{{ 'general.surname' | translate }}"
              formControlName="Surname" />
          </div>
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-2 label">*{{ "general.password" | translate }}:</div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input type="password" autocomplete="new-password" pInputText formControlName="Password"
              placeholder="{{ 'general.password' | translate }}" />
          </div>
        </div>
        <div class="col-md-2 label">
          *{{ "general.confirm_password" | translate }}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input autocomplete="off" type="password" pInputText formControlName="ConfirmPassword"
              placeholder="{{ 'general.confirm_password' | translate }}" />
          </div>
        </div>
      </div>
      <div class="row">
        <div *ngIf="error" class="col-md-12 errormessage">
          {{ errorMessage }}
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="step === 2">
    <div class="note">
      {{ "bikeshop.users.select_role" | translate }}
    </div>
    <!-- <div *ngFor="let role of roles; let i = index" class="row margin-top-8">
      <div class="col-md-11 label" *ngIf="role.name!=='admin' || isAdmin">
        <span class="role">{{ role.name }}: </span>{{ role.description }}
      </div>
      <div class="col-md-1" *ngIf="role.name!=='admin' || isAdmin">
        <p-inputSwitch
          [disabled]="role.name === 'technician' && allocatedTechnicians >= techniciansAllowed"
          (ngModelChange)="modelChanged($event, i)"
          [(ngModel)]="UserRoles[i]"
        ></p-inputSwitch>
      </div>
    </div>
    <div class="row margin-top-16" *ngIf="allocatedTechnicians >= techniciansAllowed" >
      <div class="col-md-12 red bold">
        {{ 'bikeshop.users.technician_limit_reached' | translate }}
      </div>
    </div>
    <div class="row">
      <div *ngIf="error" class="col-md-12 errormessage">
        {{ errorMessage }}
      </div>
    </div>
  </div> -->
    <div class="row margin-top-8" *ngIf="allocatedTechnicians >= techniciansAllowed && isWorkshop">
      <div class="col-md-12 red bold">
        {{ 'bikeshop.users.technician_limit_reached' | translate }}
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="isWorkshop">
      <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
        <span>{{ 'bikeshop.roles.technician' | translate }}: </span>{{null ?
        ('***' + ('bikeshop.users.user_already_technician' | translate)) : ('bikeshop.roles.technician_description' | translate) }}
      </div>
      <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
        <p-inputSwitch [disabled]="(allocatedTechnicians >= techniciansAllowed && (!isTechnician && !isFitter))"
          (ngModelChange)="modelChanged($event, 'Technician')" [(ngModel)]="isTechnician"></p-inputSwitch>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="isWorkshop">
      <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
        <span>{{ 'bikeshop.roles.fitter' | translate }}: </span>{{null ?
        ('***' + ('bikeshop.users.user_already_technician' | translate)) : ('bikeshop.roles.fitter_description' | translate) }}
      </div>
      <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
        <!--      todo (dcorbett) no (isFitterOtherStore) -->
        <p-inputSwitch [disabled]="(allocatedTechnicians >= techniciansAllowed && (!isTechnician && !isFitter))"
          (ngModelChange)="modelChanged($event, 'Fitter')" [(ngModel)]="isFitter"></p-inputSwitch>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-11 label" *ngIf="isCurrentUserAdmin">
        <span>{{ 'bikeshop.roles.admin' | translate }}: </span>{{ 'bikeshop.roles.admin_description' | translate }}
      </div>
      <div class="col-md-1" *ngIf="isCurrentUserAdmin">
        <p-inputSwitch (ngModelChange)="modelChanged($event, 'Admin')" [(ngModel)]="isAdmin"></p-inputSwitch>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="isWorkshop">
      <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
         <span>{{ 'bikeshop.roles.workshop_manager' | translate }}: </span>{{
        'bikeshop.roles.workshop_manager_description' | translate }}
      </div>
      <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
        <p-inputSwitch (ngModelChange)="modelChanged($event, 'WorkshopManager')"
          [(ngModel)]="isWorkshopManager"></p-inputSwitch>
      </div>
    </div>
    
    <div class="row margin-top-8" *ngIf="isWorkshop">
      <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
        <span>{{ 'bikeshop.roles.service_lead' | translate }}
          : </span>{{ 'bikeshop.roles.service_lead_description' | translate }}
      </div>
      <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
        <p-inputSwitch (ngModelChange)="modelChanged($event, 'ServiceLead')"
          [(ngModel)]="isServiceLead"></p-inputSwitch>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="partner.PartnerType === 1">
      <div class="col-md-11 label" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
        <span>{{ 'bikeshop.roles.shop_ride_admin' | translate }}
          : </span>{{ 'bikeshop.roles.shop_ride_admin_description' | translate }}
      </div>
      <div class="col-md-1" *ngIf="isCurrentUserAdmin || isCurrentUserWorkshopManager">
        <p-inputSwitch (ngModelChange)="modelChanged($event, 'ShopRideAdmin')"
          [(ngModel)]="isShopRideAdmin"></p-inputSwitch>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-md-3">
        <button *ngIf="step > 1" pButton type="button" class="p-button-raised full-width" (click)="back()"
          label="{{ 'bikeshop.modal.shedule_service.button.back' | translate }}" [disabled]="busy"></button>
      </div>
      <div class="col-md-6"></div>
      <div class="col-md-3" *ngIf="step === 1">
        <button pButton type="button" class="p-button-raised full-width" (click)="next()"
          label="{{ 'bikeshop.modal.shedule_service.button.next' | translate }}"
          [disabled]="busy || userLinkedToPartner"></button>
      </div>
      <div class="col-md-3" *ngIf="step === 2">
        <button pButton type="button" class="p-button-raised full-width icon" iconPos="right"
          (click)="createUser(UserForm.value)" label="{{
          'bikeshop.modal.add_edit_user.technician_form.button.save_user'
            | translate
        }}" [disabled]="busy || userLinkedToPartner"></button>
      </div>
    </div>
  </div>

  <p-confirmDialog key="user_key" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>